// TikTok links & metadata. Replace thumbnail URLs when you have branded ones.
export const TIKTOK_PROFILE_URL = "https://www.tiktok.com/@babacarbusinesscompany";
export const TIKTOK_HANDLE = "@babacarbusinesscompany";

export const TIKTOK_VIDEOS = [
  {
    id: "v1",
    url: "https://vm.tiktok.com/ZN8JMLjsg/",
    // Neutral, on-brand cover image (owner can swap later)
    cover: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
  },
  {
    id: "v2",
    url: "https://vm.tiktok.com/ZN8J6EYxt/",
    cover: "https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
  },
  {
    id: "v3",
    url: "https://vm.tiktok.com/ZN8JM6RPj/",
    cover: "https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
  },
  {
    id: "v4",
    url: "https://vm.tiktok.com/ZN8JMdF3g/",
    cover: "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
  },
];
